<template>
  <v-dialog
    v-if="showDialog"
    :model-value="exportJSONDialog"
    max-width="400"
    @click:outside="cleanUpAndCloseDialog"
  >
    <v-card>
      <v-card-title class="pt-4">Export JSON for POST</v-card-title>
      <v-select
        v-model="burstingParameterRevision"
        prepend-inner-icon="mdi-landslide"
        :items="getRevisionSet(REVISION_KEY.BURSTING_PARAMETER)"
        class="my-2 mx-4"
        label="Select bursting parameter revision"
        color="primary"
        @click.stop
        hide-details
        item-title="name"
        filled
        item-text="id"
        item-value="id"
      />
      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="exportJSONLoading"
          color="primary"
          text
          :disabled="exportJSONLoading"
          @click="onExportJson"
        >
          Export
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { REVISION_KEY } from '@/components/constant'

const store = useStore()

const burstingParameterRevision = ref(null)

const exportJSONDialog = computed(() => store.state.stabSchematisation.exportJSONDialog)
const schematisationToExport = computed(() => store.state.stabSchematisation.currentOverviewItem)
const exportJSONLoading = computed(() => store.state.stabSchematisation.exportJSONLoading)

const currentProject = computed(() => store.state.project.currentProject)

const parameterSetName = computed(() => store.getters['project/parameterSetName'])

const showDialog = computed(() => schematisationToExport.value?.id > 0)

const currentBurstingParameterRevision = computed(() => {
  return currentProject.value?.currentprojectuser[REVISION_KEY.BURSTING_PARAMETER]
})

watch(exportJSONDialog, (value) => {
  if (value) {
    burstingParameterRevision.value = currentBurstingParameterRevision.value || null
  }
})

const toggleExportJsonDialog = () => store.dispatch('stabSchematisation/toggleExportJsonDialog')
const exportJSON = (schematisationId, revisionId) =>
  store.dispatch('stabSchematisation/exportJSON', { schematisationId, revisionId })

const onExportJson = async () => {
  try {
    await exportJSON(schematisationToExport.value.id, burstingParameterRevision.value)
  } catch (e) {
    console.log(e)
  } finally {
    await cleanUpAndCloseDialog()
  }
}

const getRevisionSet = (parameter) => {
  return currentProject.value[parameterSetName.value(parameter)]
}

const cleanUpAndCloseDialog = async () => {
  await toggleExportJsonDialog()
}
</script>
